import {
  createContext,
  use,
  useRef,
  type PropsWithChildren,
  type RefObject,
} from "react";
import { EDITOR_TAB_PANEL_SCROLL_REGION } from "@/features/sparxsEditor/constants/editorScrollRegions";
import { cn } from "@/lib/utils";

const EditorTabPanelScrollContext =
  createContext<RefObject<HTMLDivElement | null> | null>(null);

export const useEditorTabPanelScrollRef =
  (): RefObject<HTMLDivElement | null> | null =>
    use(EditorTabPanelScrollContext);

export interface EditorTabPanelScrollContainerProps extends PropsWithChildren {
  className?: string;
}

export const EditorTabPanelScrollContainer = ({
  className,
  children,
}: EditorTabPanelScrollContainerProps) => {
  const tabPanelRef = useRef<HTMLDivElement | null>(null);

  return (
    <EditorTabPanelScrollContext value={tabPanelRef}>
      <div
        ref={tabPanelRef}
        data-editor-scroll-region={EDITOR_TAB_PANEL_SCROLL_REGION}
        className={cn("min-h-0 flex-1 overflow-y-auto", className)}
      >
        {children}
      </div>
    </EditorTabPanelScrollContext>
  );
};
